// extracted by mini-css-extract-plugin
export var accent = "_br-4";
export var add = "_br-j";
export var addIcon = "_br-k";
export var deleteIcon = "_br-i";
export var disabled = "_br-9";
export var ellipsis = "_br-f";
export var error = "_br-3";
export var form = "_br-5";
export var hideFocus = "_br-2";
export var icon = "_br-7";
export var input = "_br-e";
export var listItem = "_br-h";
export var mediumHeight = "_br-b";
export var noBorder = "_br-8";
export var noRadius = "_br-1";
export var shortHeight = "_br-a";
export var tallHeight = "_br-c";
export var textInput = "_br-0";
export var vertical = "_br-g";
export var veryTallHeight = "_br-d";
export var widget = "_br-6";